import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useCoapplicantStore from '../../../store/coapplicantStore/useCoapplicantStore';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import { locator } from '../../../testing/e2e-locator/locator';

const CoapplicantIncomeSection = (): ReactNode => {
  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const {
    computed: {
      coapplicantAdditionalIncomeAmount,
      coapplicantAdditionalIncomeFrequency,
      coapplicantAdditionalIncomeStatus,
      coapplicantAdditionalIncomeType,
    },
  } = useCoapplicantStore();

  return (
    <span data-testid={locator.components.coapplicantIncomeSection.root}>
      <div className="head">
        <h3 data-testid={locator.components.coapplicantIncomeSection.h3}>
          {t('CoapplicantReviewPage.additionalIncome')}
        </h3>
        <Link
          data-testid={locator.components.coapplicantIncomeSection.editLink}
          to={`/applicant/${vehicleId}/coapp-edit-income`}
        >
          {t('CoapplicantReviewPage.edit')}
        </Link>
      </div>

      <ul>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.status')}</dt>
            <dd
              data-testid={locator.components.coapplicantIncomeSection.status}
            >
              {coapplicantAdditionalIncomeStatus}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.type')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantIncomeSection.incomeType
              }
            >
              {coapplicantAdditionalIncomeType}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.amount')}</dt>
            <dd
              data-testid={locator.components.coapplicantIncomeSection.amount}
            >
              {coapplicantAdditionalIncomeAmount}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.frequency')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantIncomeSection.frequency
              }
            >
              {coapplicantAdditionalIncomeFrequency}
            </dd>
          </dl>
        </li>
      </ul>
    </span>
  );
};

export default CoapplicantIncomeSection;
